import { render, staticRenderFns } from "./profitLossLimitHistory.vue?vue&type=template&id=689000c0&"
import script from "./profitLossLimitHistory.vue?vue&type=script&lang=js&"
export * from "./profitLossLimitHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports